/**
 * T-65 — Aufklapp-Zustand der Mail-Ordner in der Sidebar, über das Neuladen
 * hinweg. Wer `Posteingang/5.Kundenmails/Team CLL/…` aufgeklappt hat, soll die
 * Struktur nach dem Neuladen nicht jedes Mal neu aufklappen müssen.
 *
 * Schlüssel je Eintrag bleibt `postfach:ordner` (wie in NavigationLayout).
 * Einträge zu inzwischen gelöschten Ordnern sind harmlos — sie passen auf
 * keine Zeile mehr und werden beim nächsten Umschalten nicht mitgeschrieben,
 * sofern sie nicht mehr im Set stehen.
 *
 * Der Speicher wird übergeben, nicht über `window.localStorage` geholt: so
 * sind die Funktionen ohne DOM prüfbar, und ein fehlender oder gesperrter
 * Speicher (privates Fenster) bricht nichts.
 */

export const MAIL_ORDNER_AUFGEKLAPPT_KEY = "kmvs.mail.ordnerAufgeklappt";

/** Obergrenze, damit ein über Jahre gewachsener Eintrag nicht ausufert. */
const MAX_EINTRAEGE = 500;

type Lesespeicher = Pick<Storage, "getItem">;
type Schreibspeicher = Pick<Storage, "setItem">;

export function leseAufgeklappt(speicher: Lesespeicher | null | undefined): Set<string> {
    try {
        const roh = speicher?.getItem(MAIL_ORDNER_AUFGEKLAPPT_KEY);
        if (!roh) return new Set();
        const daten: unknown = JSON.parse(roh);
        if (!Array.isArray(daten)) return new Set();
        return new Set(daten.filter((x): x is string => typeof x === "string"));
    } catch {
        return new Set();
    }
}

export function schreibeAufgeklappt(speicher: Schreibspeicher | null | undefined, aufgeklappt: ReadonlySet<string>): void {
    try {
        speicher?.setItem(MAIL_ORDNER_AUFGEKLAPPT_KEY, JSON.stringify(Array.from(aufgeklappt).slice(-MAX_EINTRAEGE)));
    } catch {
        /* Speicher voll oder gesperrt — dann eben nur für diese Sitzung. */
    }
}

/** `window.localStorage` ohne Ausnahme — in manchen Umgebungen wirft schon der Zugriff. */
export function browserSpeicher(): Storage | null {
    try {
        return typeof window !== "undefined" ? window.localStorage : null;
    } catch {
        return null;
    }
}
